// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3cceA","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1r61K","obliqueLine":"membershipbadge_obliqueLine__3cK2B"};